import { Filter, X } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';

/**
 * What the filters are hiding, and one click to stop.
 *
 * The chart draws only what a filter left standing, which is the point — but a
 * chart missing most of the company has to say so, or it reads as the whole
 * company.
 */
export function FilterBanner() {
  const filtered = useAppStore((s) => s.filtered);
  const departmentFilter = useAppStore((s) => s.departmentFilter);
  const squadFilter = useAppStore((s) => s.squadFilter);
  const onlyChanged = useAppStore((s) => s.onlyChanged);
  const squads = useAppStore((s) => s.planSquads.squads);

  const setDepartmentFilter = useAppStore((s) => s.setDepartmentFilter);
  const setSquadFilter = useAppStore((s) => s.setSquadFilter);
  const setOnlyChanged = useAppStore((s) => s.setOnlyChanged);

  if (!filtered.keep) return null;

  const named = [
    ...(onlyChanged ? ['in this scenario'] : []),
    ...departmentFilter,
    ...squadFilter.map((id) => squads.find((squad) => squad.id === id)?.name ?? id),
  ];

  return (
    <div className="card-in flex max-w-[560px] items-center gap-2 rounded-xl border border-[var(--color-brand)]/40 bg-[var(--color-brand-soft)] px-3 py-1.5 text-[12px] shadow-[var(--shadow-card)] backdrop-blur">
      <Filter size={13} className="shrink-0 text-[var(--color-brand)]" />
      <span className="truncate text-[var(--color-ink)]">
        <strong className="font-semibold tabular-nums">{filtered.matched}</strong> of{' '}
        <span className="tabular-nums">{filtered.total}</span> shown
        {named.length > 0 ? <span className="text-[var(--color-ink-2)]"> · {named.join(', ')}</span> : null}
        {filtered.context > 0 ? (
          <span className="text-[var(--color-ink-3)]">
            {' '}
            (+{filtered.context} manager{filtered.context === 1 ? '' : 's'} for context)
          </span>
        ) : null}
      </span>
      <button
        type="button"
        // Named, because the colour key has a Clear too and "Clear, Clear" is what
        // a screen reader would otherwise read out.
        aria-label="Clear filters"
        onClick={() => {
          setDepartmentFilter([]);
          setSquadFilter([]);
          setOnlyChanged(false);
        }}
        className="flex shrink-0 items-center gap-1 rounded-md px-1.5 py-0.5 font-medium text-[var(--color-brand)] hover:bg-[var(--color-surface)]"
      >
        <X size={12} /> Clear
      </button>
    </div>
  );
}
